import { queryOptions, useQuery } from '@tanstack/react-query';

import { authApi } from '../api/auth-api';

import { authKeys } from './auth-keys';

/** Public preview of an invitation; a 401 means the token is invalid, expired or used. */
export function invitationQueryOptions(token: string) {
  return queryOptions({
    queryKey: authKeys.invitation(token),
    queryFn: () => authApi.invitationPreview(token),
    retry: false,
    staleTime: 60_000,
    meta: { silentError: true },
  });
}

export function useInvitation(token: string | undefined) {
  return useQuery({ ...invitationQueryOptions(token ?? ''), enabled: Boolean(token) });
}
